export const FILTER_CONTROL_CLASS =
  'min-h-10.5 max-w-full gap-2 rounded-sm border px-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';

export function filterControlState(selected: boolean) {
  return selected
    ? 'border-indigo-200 bg-indigo-50 text-indigo-800 hover:border-indigo-300 hover:bg-indigo-100/70'
    : 'border-gray-300 bg-white text-gray-700 hover:border-indigo-300 hover:bg-indigo-50/40';
}

export function filterIconState(selected: boolean) {
  return selected ? 'text-indigo-600' : 'text-gray-500';
}
